import type { AppMode } from '@iheartjane/types';
/* eslint-disable-next-line no-restricted-imports */
import type { LDSingleKindContext } from 'launchdarkly-js-client-sdk';

import { guestBucketForDeviceID } from './guestBucket';

/** Default context key values */
const DEFAULT_USER_KEY = 'TEMPORARY_USER_ID';

interface JaneUserContext extends LDSingleKindContext {
  key: string;
}

export const DEFAULT_USER_CONTEXT: JaneUserContext = {
  anonymous: true,
  /**
   * Provide a temporary user ID so LaunchDarkly doesn't assign
   * its own anonymous ID every time we initialize the client.
   */
  key: DEFAULT_USER_KEY,
  kind: 'user',
};

interface UserContext {
  email?: string | null;
  firstName?: string | null;
  id?: number | string | null;
  lastName?: string | null;
}

interface ExtraContextAttributes {
  appMode?: AppMode;
  operatorId?: number;
  organizationId?: number | null;
  state?: string | null;
  storeId?: string | number;
}

interface FlagContextProps {
  extraAttributes?: ExtraContextAttributes;
  janeDeviceId?: string | null;
  user?: UserContext;
}

export const getFlagContext = ({
  extraAttributes,
  janeDeviceId,
  user,
}: FlagContextProps = {}): JaneUserContext => {
  let context = {
    ...DEFAULT_USER_CONTEXT,
  };

  if (user?.id) {
    context = {
      ...context,
      anonymous: false,
      key: user?.id.toString(),
      email: user?.email,
      firstName: user?.firstName,
      lastName: user?.lastName,
    };
  } else if (janeDeviceId) {
    context.key = guestBucketForDeviceID(janeDeviceId);
  }

  // always add jdid as an attribute if exists
  if (janeDeviceId) {
    context = {
      ...context,
      jdid: janeDeviceId,
    };
  }

  return { ...context, ...extraAttributes };
};
